import { render, staticRenderFns } from "./BookingStats.vue?vue&type=template&id=caa56ce0"
import script from "./BookingStats.vue?vue&type=script&lang=js"
export * from "./BookingStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports